/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1AssetType } from '../models/V1AssetType';
import { HttpFile } from '../http/http';

export class AdvertisingPlatformServiceUpdateAssetRequest {
    /**
    * Date and time the asset was created at
    */
    'createTime'?: Date;
    /**
    * Date and time the asset was last updated
    */
    'updateTime'?: Date;
    /**
    * Date and time the asset was deleted
    */
    'deleteTime'?: Date;
    /**
    * ID of the org that the asset is connected to
    */
    'orgId'?: string;
    /**
    * File location Key
    */
    'key'?: string;
    /**
    * Bucket that the asset belongs to
    */
    'bucket'?: string;
    /**
    * Name assigned to the asset
    */
    'name'?: string;
    'type'?: V1AssetType;
    /**
    * True if this asset is set as the default branding image.
    */
    'isDefault'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "createTime",
            "baseName": "create_time",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updateTime",
            "baseName": "update_time",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "deleteTime",
            "baseName": "delete_time",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "key",
            "baseName": "key",
            "type": "string",
            "format": ""
        },
        {
            "name": "bucket",
            "baseName": "bucket",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "V1AssetType",
            "format": ""
        },
        {
            "name": "isDefault",
            "baseName": "is_default",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return AdvertisingPlatformServiceUpdateAssetRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

